import React, { useEffect, useCallback } from "react";
import { Button } from "react-bootstrap";
import "./BreakScreen.scss"; // This is where we will import our CSS from
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setTimeLeft } from "../../store/fullLengthExam";

const BreakScreen = ({ onBreakEnd }) => {
  const fullLengthExam = useSelector((state) => state.fullLengthExam);
  const { timeLeft } = fullLengthExam;
  const dispatch = useDispatch();

  useEffect(() => {
    if (timeLeft === 0) {
      onBreakEnd();
    }
    const timer = setTimeout(() => {
      dispatch(setTimeLeft(timeLeft - 1));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  const formatTime = useCallback((seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  }, []);

  return (
    <div className="break-screen-container">
      <div className="break-time-counter">
        <p>Remaining Break Time:</p>
        <h1>{formatTime(timeLeft)}</h1>
        <Button variant="warning" onClick={onBreakEnd}>
          Resume Testing
        </Button>
      </div>
      <div className="break-instructions">
        <h3>This Module is Over</h3>
        <p>
          You can resume this practice test as soon as you're ready to move on.
          On test day, you'll wait until the clock counts down. Read below to
          see how breaks work on test day.
        </p>

        <br />
        <br />
        <h3>Take a Break: Do Not Close Your Device</h3>
        <p>
          You may leave the room, but do not disturb students who are still
          testing.
        </p>
        <br />
        <p>Testing won't resume until you return.</p>
        <br />
        <h4>Follow these rules during the break:</h4>
        <br />

        <ol>
          <li>
            Do not access your phone, smartwatch, textbooks, notes, or the
            internet.
          </li>
          <li>Do not eat or drink in the test room.</li>
          <li>
            Do not speak in the test room; outside the test room, do not discuss
            the exam with anyone.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default BreakScreen;
